import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"

import StyledPaper from "/components/paper"

import genericImage from '/assets/dashboard/active-passes.png'

const ActivePasses = () => {

  const navigate = useNavigate()

  return (
    <StyledPaper width={250} height={250}>
      <div onClick={() => navigate("/active-passes")} className="link flex flex-col items-center justify-top h-full">
        <Typography variant="h5">Active Passes</Typography>
      </div>
      <div onClick={() => navigate("/active-passes")} className="link relative">
        {randomPassImages()}
      </div>
    </StyledPaper>
  )
}

export default ActivePasses

const getImageStyle = index => {

  const left = "28%"
  return { position: "absolute", left, bottom: 30, height: "130px", display: "inline-block", transform: `rotate(${(180 / 6 * index) - 120}deg)`, filter: `drop-shadow(0 8px 12px rgba(10, 10, 10, 0.5)) brightness(${40 + (index * 15)}%)` }
}

const randomPassImages = () => {
  const images = []

  for (let i = 0; i < 4; i++) {
    const style = getImageStyle(i)
    images.push(<img src={genericImage} style={style} key={i} />)
  }

  return images
}